module.exports = __webpack_public_path__ + "img/icon_search2.87cc94e6.png";